module.exports = __webpack_public_path__ + "static/blog01-29fd5bf36ef811ca5f973ef779f2b78e.png";